import React, { useEffect, useState } from "react";
import { DatePicker, Table, Checkbox, Button, Modal } from "antd";
import { renderToStaticMarkup } from "react-dom/server";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import TableTop from "Components/UI/TableTop";
import { endOfMonth, format, startOfMonth } from "date-fns";
import dayjs from "dayjs";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import Select from "react-select";
import ReportTools from "Components/UI/ReportTools";
import MonthOption from "Components/Form/MonthSelect";
import YearOption from "Components/Form/YearSelect";
import { usePayslipReportQuery } from "AppQuries/report/get-payslip-report";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Payslip from "Components/UI/Payslip/Payslip";
import { useExpiryDocReportQuery } from "AppQuries/report/get-expiry-doc-report";
import { BackIcon } from "Components/UI/Icon/Icons";
const { RangePicker } = DatePicker;
const ExpiryDocReport = () => {
  const userData = useSelector(loggedInUser);
  const [isDownloading, setIsDownloading] = useState(false);
  const [filterReport, setFilterReport] = useState(true);
  const [inputfilter, setInputfilter] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedPayslip, setSelectedPayslip] = useState(null);
  const [payslip, setPayslip] = useState([]);
  const [companyDetails, setCompanyDetails] = useState({
    ...userData,
  });
  const [filter, setFilter] = useState({
    fromDate: format(startOfMonth(new Date()), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date()), "yyyy-MM-dd"),
    companyCode: userData.companyCode,
    locationCode: userData.selectedLocationCode,
    userId: userData?.userID,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
    employeeCode: 0,
    passCode: 0,
  });

  const [employeeCode, setEmployeeCode] = useState(0);
  const [reportData, setReportData] = useState([]);

  const {
    data,
    isFetching,
    isError,
    error,
    refetch: getReport,
  } = useExpiryDocReportQuery(
    {
      ...filter,
      employeeCode: employeeCode,
    },
    {
      enabled: !!filter.fromDate && !!filter.companyCode,
    }
  );

  useEffect(() => {
    if (data?.length) {
      setReportData(
        data?.map((d, _id) => ({
          ...d,
          id: _id + 1,
          key: _id,
        })) || []
      );
    }
  }, [data]);

  const { data: employees } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const employeeOptions =
    employees
      ?.filter((d) => d.isActive)
      .map((o) => ({
        id: o.employeeCode,
        label: `${o.uniqueId}-${o.fullName}`,
        value: o.employeeCode,
      })) || [];
  const [isFilterVisible, setIsFilterVisible] = useState(true);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      sorter: (a, b) => a.uniqueID - b.uniqueID,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
    },
    {
      title: "passName",
      dataIndex: "passName",
    },
    {
      title: "Expiry Date",
      dataIndex: "expiryDate",
      sorter: (a, b) => a.expiryDate.length - b.expiryDate.length,
      render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },
  ];

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    reportData,
    searchColumns
  );
  if (isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Employee Documents Expiry Report</h4>
                <h6>Employee Documents Expiry Summary Report</h6>
              </div>
            </div>

            <ReportTools
              columns={columns}
              data={reportData}
              fileName={`Employee Documents Expiry Report`}
              pdfTheme="striped"
              // refresh={getReport}
              refresh={() => {
                setSelectedRowKeys([]);
                getReport();
              }}
            />
            <div className="page-btn">
              <Link
                to={`${all_routes.report_list}`}
                f
                className="btn btn-secondary"
              >
                <BackIcon className="me-2" />
                Back
              </Link>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={true}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                
                <div className="card-body pb-0">
                  <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <label className="form-label">Employee </label>
                          <Select
                            className="select"
                            options={employeeOptions}
                            placeholder="Employee"
                            value={employeeOptions.find(
                              (option) => option.value === employeeCode
                            )}
                            onChange={(e) => {
                              setEmployeeCode(e?.value || 0);
                            }}
                            isClearable
                            menuPortalTarget={document.body}
                            menuPosition="absolute"
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 111,
                              }),
                              menuPortal: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <label className="form-label">Start Date – End Date</label>
                          <RangePicker
                            dateFormat="YYYY-MM-DD"
                            className=""
                            dafaultValue={[
                              dayjs(filter.fromDate, "YYYY-MM-DD"),
                              dayjs(filter.toDate, "YYYY-MM-DD"),
                            ]}
                            onChange={(date, dateFormat) => {
                              setFilter((prev) => ({
                                ...prev,
                                fromDate: dateFormat[0],
                                toDate: dateFormat[1],
                              }));
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label className="form-label">&nbsp;</label>
                          <Link
                            className="btn btn-filters ms-auto"
                            onClick={() => {
                              setSelectedRowKeys([]);
                              getReport();
                            }}
                            type="button"
                          >
                            <i
                              data-feather="search"
                              className="feather-search"
                            />
                            {isFetching ? (
                              <>
                                <i className="fas fa-spinner fa-spin me-2"></i>
                                Loading...
                              </>
                            ) : (
                              <>Filter</>
                            )}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Table
                  //   rowSelection={rowSelection}
                  columns={columns}
                  dataSource={filteredData}
                  pagination={false}
                  rowKey={(record) => record.key}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Modal
        title="Payslip Details"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="close" onClick={handleCancel}>
            Close
          </Button>,
        ]}
        width={1000}
      >
        {selectedRowKeys?.map((selectedPayslip, key) => {
          return (
            <Payslip
              payslipDetails={reportData[selectedPayslip]}
              companyDetails={companyDetails}
              key={key}
            />
          );
        })}
      </Modal> */}
    </>
  );
};

export default ExpiryDocReport;
